// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_deP","index":"styles_index__BiBOy"};